import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import { UploadPreview } from '@ifca-root/react-component/src/components/Avatar/UploadPreview'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { VoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomTextField'
import { FileUploadInput as DocUploadInput } from '@ifca-root/react-component/src/components/Input/FileUploadInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import { changeDateFormat } from '@ifca-root/react-component/src/helpers/Functions/dateFunction'
import useUploadAttachment from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import { ListItem, ListItemText, MenuItem, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import AuditLog from 'assets/icons/MFRS16/auditlog.svg'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { AccountFooter } from 'components/Footer/AccountFooter'
import { TotalAmountFooter } from 'components/Footer/TotalAmountFooter'
import { FormAllocationTableContent } from 'components/Table/FormAllocationTableContent'
import { DropdownTextfield } from 'containers/ARAPModule/Components/DropdownTextField'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  DocumentListingDocument,
  GetArRefundbyStatusDocument,
  RecordStatus,
  useCreateArRefundMutation,
  useDocumentListingLazyQuery,
  useGetArAllocationDocumentLazyQuery,
  useGetBankAccountQuery,
  useGetBankBalanceAmountByBankAccountLazyQuery,
  useGetCreditCardTypeQuery,
  useGetDebtorAccountListingQuery,
  useGetDocNumTitleQuery,
  useGetDocumentDateValidationQuery,
  useGetPaymentMethodQuery,
  useLatestOpenPeriodCheckingDateQuery,
  useUpdateArRefundMutation,
} from 'generated/graphql'
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import {
  formatDashDate,
  getDatePlusDay,
} from 'helpers/StringNumberFunction/FormatDate'
import { amtNumStr, amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { CommonYupValidation } from 'helpers/YupSchema/yup'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import * as yup from 'yup'
import '../ARRefund.scss'
interface ARRefundProps {
  CompanyID: string
  DebtorAccountID: string
  RefundID: string
  DocDate: Date
  TrxDate: string
  DocAmt: number
  RefNo: string
  Description: string
  Remark: string
  Attachment: null
  debitAmt: number
  approval: string
  user: string
  BankAccountID: string
  BankName: string
  PaymentMethodID: string
  CreditCardID: string
  ChequeNo: string
  ChequeDate: Date
  uploadAttach: string
  Allocation: any[]
}
interface FavARRefundProps {
  Name: string
}

export const ARRefundForm = (props: any) => {
  useEffect(() => {
    document.title = 'AR - Refund'
  }, [])

  const { formMode, type } = props
  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }

  /* -------------------------------------------- */
  /*               STATE & VARIABLES              */
  /* -------------------------------------------- */
  let history = useHistory()
  let location = useLocation()
  const editData = location?.state as any
  const { CompanyID, RefundID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [openExitDialog, setopenExitDialog] = useState(false)
  const [RefundValidation, setRefundValidation] = useState(false)
  const [valuepicked, setValuePicked] = useState<String>(null)
  const [isSubmit, setIsSubmit] = useState(false)
  const [voiceRemark, setVoiceRemark] = useState('')

  // Change Tax descrition into code number
  const [cost, setCost] = useState(amtNumStr(editData?.Amount) ?? 0)
  const [totalAmt, setTotalAmt] = useState(0.0)
  const [amount, setAmount] = useState(0.0)
  const [openExitConf, setOpenExitConf] = useState(null)
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [allocatedObj, setAllocatedObj] = useState({})
  const [initDocs, setInitDocs] = useState([])
  useEffect(() => {
    if (editData?.Attachment) {
      setInitDocs(editData?.Attachment)
    }
  }, [editData])
  const [audioInput, setAudioInput] = useState(editData?.Remark ?? '')
  const [record, setRecord] = useState(false)
  const [singleRemark, setSingleRemark] = useState(null)
  const [text, setText] = useState(editData?.Remark ?? '')
  const handleSingleRemark = remark => {
    setSingleRemark(remark)
  }

  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  /* -------------------------------------------- */
  /*               QUERY & MUTATION               */
  /* -------------------------------------------- */
  // const {
  //   loading: DebtorAccountLoading,
  //   data: { getDebtorAccount } = {
  //     getDebtorAccount: [],
  //   },
  // } = useGetDebtorAccountQuery({
  //   fetchPolicy: 'network-only',
  //   variables: {
  //     CompanyID: CompanyID,
  //   },
  //   onError: ({ message }) => {
  //     let error = message?.substring(15)
  //     setErrMessage(error)
  //     setErrDialog(true)
  //   },
  // })

  const {
    loading: DebtorAccountLoading,
    data: { getDebtorAccountListing } = { getDebtorAccountListing: [] },
  } = useGetDebtorAccountListingQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  //PaymentMethod
  const {
    loading: PaymentMethodLoading,
    data: { getPaymentMethod } = { getPaymentMethod: [] },
  } = useGetPaymentMethodQuery({
    fetchPolicy: 'network-only',
    onCompleted: () => {},
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: bankAccountLoading,
    data: { getBankAccount } = { getBankAccount: [] },
  } = useGetBankAccountQuery({
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RecordStatus: RecordStatus?.Active,
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: docNumHeaderLoading,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RefTable: 'AR_Refund',
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: openPeriodCheckDateLoading,
    data: { latestOpenPeriodCheckingDate } = {
      latestOpenPeriodCheckingDate: {} as any,
    },
  } = useLatestOpenPeriodCheckingDateQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  //CreditCardType
  const {
    loading: CreditCardTypeLoading,
    data: { getCreditCardType } = { getCreditCardType: [] },
  } = useGetCreditCardTypeQuery({
    fetchPolicy: 'network-only',
    variables: {},
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: DocDateValidationLoading,
    data: { getDocumentDateValidation } = { getDocumentDateValidation: [] },
  } = useGetDocumentDateValidationQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMessage(errorMessage)
    },
    fetchPolicy: 'network-only',
  })

  const [
    createARRefund,
    {
      loading: createARRefundLoading,
      called: createARRefundCalled,
      error: createARRefundError,
    },
  ] = useCreateArRefundMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ createARRefund }) => {
      setTimeout(() => {
        if (!!isSubmit) {
          history.push({
            pathname: `/account-receivable/${CompanyID}/refund/${createARRefund?.RefundID}/preview`,
          })
        } else {
          history.push({
            pathname: `/account-receivable/${CompanyID}/refund`,
            state: { success: true, msgMode: 'create' },
          })
        }
      }, 500)
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
    },
  })

  const [
    updateARRefund,
    {
      loading: updateARRefundLoading,
      called: updateARRefundCalled,
      error: updateARRefundError,
    },
  ] = useUpdateArRefundMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setTimeout(() => {
        if (!!isSubmit) {
          history.push({
            pathname: `/account-receivable/${CompanyID}/refund/${RefundID}/preview`,
          })
        } else {
          history.push({
            pathname: `/account-receivable/${CompanyID}/refund`,
            state: { success: true, msgMode: 'update' },
          })
        }
      }, 500)
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
    },
  })

  const [
    loadAllocationDocument,
    {
      loading: getAllocationDocumentLoading,
      called: getAllocationDocumentCalled,
      error: getAllocationDocumentError,
      data: { getAllocationDocument } = { getAllocationDocument: [] },
    },
  ] = useGetArAllocationDocumentLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getAllocationDocument }) => {
      let arr = []
      if (getAllocationDocument?.length > 0) {
        getAllocationDocument
          // ?.filter(
          //   alloc =>
          //     Number(alloc?.BalanceAmt) +
          //       Number(allocatedObj[alloc[`${alloc?.CreditOrDebit}ID`]] ?? 0) >
          //       0 && (!alloc?.CanAllocate ? alloc?.AllocationID : true)
          // )
          // ?.sort((x, y) => {
          //   return y?.CanAllocate - x?.CanAllocate
          // })
          ?.map((alloc, index) => {
            arr.push({
              AllocationID: alloc?.AllocationID,
              CreditOrDebit: alloc?.CreditOrDebit,
              DocDate: alloc?.DocDate,
              DocNo: alloc?.DocNo,
              Description: alloc?.Description,
              // for previous allocated amt on the same doc
              AllocationAmt: Number(
                allocatedObj[alloc[`${alloc?.CreditOrDebit}ID`]] ?? 0
              ),
              // balance amount + previous allocated amt on the same doc
              BalanceAmt:
                Number(alloc?.BalanceAmt) +
                Number(allocatedObj[alloc[`${alloc?.CreditOrDebit}ID`]] ?? 0),
              // credit or debit id
              [`${alloc?.CreditOrDebit}ID`]: alloc[`${alloc?.CreditOrDebit}ID`],
              // credit or debit ref table
              [`${alloc?.CreditOrDebit}RefTable`]: alloc[
                `${alloc?.CreditOrDebit}RefTable`
              ],
              // credit or debit doc no
              [`${alloc?.CreditOrDebit}DocNo`]: alloc[
                `${alloc?.CreditOrDebit}DocNo`
              ],
            })
            return alloc
          })

        append(arr)
      }
    },
  })

  const [
    getBankBalance,
    {
      loading: getBankBalanceLoading,
      data: { getBankBalanceAmountByBankAccount } = {
        getBankBalanceAmountByBankAccount: [],
      },
    },
  ] = useGetBankBalanceAmountByBankAccountLazyQuery({
    fetchPolicy: 'network-only',
    // variables: {
    //   CompanyID: CompanyID,
    //   BankAccountID: BankAccountID,
    // },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  /* -------------------------------------------- */
  /*                    USEFORM                   */
  /* -------------------------------------------- */
  const ARRefundFormSchema = yup.object().shape({
    DocDate: yup.string().required('Doc Date is Required'),
    TrxDate: yup.string().required('Transaction Date is Required'),
    RefNo: CommonYupValidation.requireField(SystemMsgs.referenceNo()),
    DebtorAccountID: yup.string().required('Debtor Name is required'),
    Description: CommonYupValidation.requireField(SystemMsgs.description()),
    PaymentMethodID: CommonYupValidation.requireField(
      'Refund Method is required'
    ),
    CreditCardID:
      RefundValidation && valuepicked?.includes('Card')
        ? CommonYupValidation.requireField('Credit Card Type is required')
        : null,
    ChequeNo: yup.string().when('PaymentMethodID', {
      is: getPaymentMethod?.find(method => method?.Name === 'Cheque')
        ?.PaymentMethodID,
      then: yup.string().required('Cheque no. is required'),
      otherwise: null,
    }),
    ChequeDate: yup.date().when('PaymentMethodID', {
      is: getPaymentMethod?.find(method => method?.Name === 'Cheque')
        ?.PaymentMethodID,
      then: yup.date().required('Cheque date is required'),
      otherwise: null,
    }),
    Remark: CommonYupValidation.requireField(SystemMsgs.remark()),

    BankAccountID: CommonYupValidation.requireField(
      'Bank Account No. is required'
    ),
    Allocation: yup.array().of(
      yup.object().shape({
        AllocationAmt: CommonYupValidation?.requireField(
          'Allocation Amt is required'
        ).nullable(),
      })
    ),
  })

  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    watch,
    getValues,
    clearErrors,
    setError,
  } = useForm<ARRefundProps>({
    defaultValues: {
      CompanyID: editData ? editData?.CompanyID : '',
      DocDate: editData ? editData?.DocDate : new Date(),
      TrxDate: editData ? editData?.TransactionDate : new Date(),
      RefNo: editData ? editData?.RefNo : '',
      DebtorAccountID: editData ? editData?.DebtorAccountID : '',
      BankAccountID: editData ? editData?.BankAccountID : '',
      PaymentMethodID: editData ? editData?.PaymentMethodID : '',
      CreditCardID: editData ? editData?.CreditCardID : '',
      ChequeNo: editData ? editData?.ChequeNo : '',
      ChequeDate: editData ? editData?.ChequeDate : new Date(),
      DocAmt: editData ? editData?.DocAmt : 0,
      Description: editData ? editData?.Description : '',
      Remark: editData ? editData?.Remark : '',
      Attachment: editData ? editData?.Attachment : '',
    },
    mode: 'onSubmit',
    resolver: yupResolver(ARRefundFormSchema),
  })

  const onSubmit = (data, status) => {
    const bankAcc = getBankAccount.find(
      acc => acc?.BankAccountID === data?.BankAccountID
    )

    const availableBalance =
      (bankAcc?.OverdraftLimit || 0) +
      parseFloat(getBankBalanceAmountByBankAccount?.[0]?.LatestLocalBalance)
    const paymentAmount = getTotalAmt()
    if (availableBalance - paymentAmount < 0) {
      setErrMessage(
        `Payment of ${amtStr(
          paymentAmount
        )} cannot be made with a balance of ${amtStr(availableBalance)}`
      )
      setErrDialog(true)
      return
    }

    if (formMode === 'add') {
      createARRefund({
        variables: {
          input: {
            CompanyID: CompanyID,
            DocDate: formatDashDate(new Date(data?.DocDate)?.toISOString()),
            TransactionDate: formatDashDate(
              new Date(data?.TrxDate)?.toISOString()
            ),
            RefNo: data?.RefNo,
            DebtorAccountID: data?.DebtorAccountID,
            PaymentMethodID: data?.PaymentMethodID,
            CreditCardID: data?.CreditCardID,
            ChequeNo: data?.ChequeNo,
            ChequeDate: data?.ChequeDate,
            ChequeExpiryDate: !!data?.ChequeDate
              ? changeDateFormat(
                  getDatePlusDay(data?.ChequeDate, 180),
                  'DD MMM YYYY'
                )
              : null,
            BankAccountID: data?.BankAccountID,
            Description: data?.Description,
            Remark: data?.Remark,
            ApprovalStatus: statusInput(status),
            Amount: getTotalAmt(),
            DocAmt: getTotalAmt(),
            Attachment: files,
          },
          allocationInput: watch('Allocation')
            ?.filter(
              alloc => Number(alloc?.AllocationAmt) !== 0 || alloc?.AllocationID
            )
            ?.map(alloc => {
              const mainCreditOrDebit =
                alloc?.CreditOrDebit === 'Debit' ? 'Credit' : 'Debit'
              return {
                ...(alloc?.AllocationID
                  ? { AllocationID: alloc?.AllocationID }
                  : null),
                AllocationAmt: Number(alloc?.AllocationAmt),
                CreditOrDebit: alloc?.CreditOrDebit,
                CompanyID: CompanyID,
                // for allocated table
                [`${alloc?.CreditOrDebit}RefTable`]: alloc?.[
                  `${alloc?.CreditOrDebit}RefTable`
                ],
                [`${alloc?.CreditOrDebit}ID`]: alloc?.[
                  `${alloc?.CreditOrDebit}ID`
                ],
                // main table
                [`${mainCreditOrDebit}RefTable`]: 'AR_Refund',
              }
            }),
        },
        refetchQueries: [
          {
            query: GetArRefundbyStatusDocument,
            variables: {
              CompanyID: CompanyID,
              StatusArr: ['ACTIVE'],
            },
          },
          {
            query: DocumentListingDocument,
            variables: {
              refTable: 'S_Attachment',
              refID: editData?.RefundID,
            },
          },
        ],
      })
      // }
    } else if (formMode !== 'add') {
      updateARRefund({
        variables: {
          input: {
            CompanyID: CompanyID,
            RefundID: RefundID,
            DocDate: formatDashDate(new Date(data?.DocDate)?.toISOString()),
            TransactionDate: formatDashDate(
              new Date(data?.TrxDate)?.toISOString()
            ),
            RefNo: data?.RefNo,
            DebtorAccountID: data?.DebtorAccountID,
            PaymentMethodID: data?.PaymentMethodID,
            CreditCardID: data?.CreditCardID,
            ChequeNo: data?.ChequeNo,
            ChequeDate: data?.ChequeDate,
            ChequeExpiryDate: !!data?.ChequeDate
              ? changeDateFormat(
                  getDatePlusDay(data?.ChequeDate, 180),
                  'DD MMM YYYY'
                )
              : null,
            BankAccountID: data?.BankAccountID,
            Description: data?.Description,
            Remark: data?.Remark,
            ApprovalStatus: statusInput(status),
            Amount: parseFloat(amtNumStr(data?.Amount)),
            DocAmt: getTotalAmt(),
            Attachment: files,
          },
          allocationInput: watch('Allocation')
            ?.filter(
              alloc => Number(alloc?.AllocationAmt) !== 0 || alloc?.AllocationID
            )
            ?.map(alloc => {
              const mainCreditOrDebit =
                alloc?.CreditOrDebit === 'Debit' ? 'Credit' : 'Debit'
              return {
                ...(alloc?.AllocationID
                  ? { AllocationID: alloc?.AllocationID }
                  : null),
                AllocationAmt: Number(alloc?.AllocationAmt),
                CreditOrDebit: alloc?.CreditOrDebit,
                CompanyID: CompanyID,
                // for allocated table
                [`${alloc?.CreditOrDebit}RefTable`]: alloc?.[
                  `${alloc?.CreditOrDebit}RefTable`
                ],
                [`${alloc?.CreditOrDebit}ID`]: alloc?.[
                  `${alloc?.CreditOrDebit}ID`
                ],
                // main table
                [`${mainCreditOrDebit}RefTable`]: 'AR_Refund',
              }
            }),
        },
        refetchQueries: [
          {
            query: GetArRefundbyStatusDocument,
            variables: {
              CompanyID: CompanyID,
              StatusArr: ['ACTIVE'],
            },
          },
          {
            query: DocumentListingDocument,
            variables: {
              refTable: 'S_Attachment',
              refID: editData?.RefundID,
            },
          },
        ],
      })
    }
  }

  let statusInput = mode => {
    let temp
    switch (mode) {
      case 'submit':
        temp = ApprovalStatus.Submit
        break
      case 'draft':
        temp = ApprovalStatus.Active
        break
      case 'approve':
        temp = ApprovalStatus.Approved
        break
      case 'reject':
        temp = ApprovalStatus.Rejected
        break
    }
    return temp
  }

  const docDateTimestamp = new Date(watch('DocDate'))
  const yearDocDate = docDateTimestamp.getFullYear()
  const monthDocDate = (docDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayDocDate = docDateTimestamp
    .getDate()
    .toString()
    .padStart(2, '0')

  const transferDate = `${yearDocDate}-${monthDocDate}-${dayDocDate}`

  const trxDateTimestamp = new Date(watch('TrxDate'))
  const yearTrxDate = trxDateTimestamp.getFullYear()
  const monthTrxDate = (trxDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayTrxDate = trxDateTimestamp
    .getDate()
    .toString()
    .padStart(2, '0')

  const trxDate = `${yearTrxDate}-${monthTrxDate}-${dayTrxDate}`

  const openPeriod1 =
    transferDate <= latestOpenPeriodCheckingDate?.StartDate ||
    transferDate >= latestOpenPeriodCheckingDate?.EndDate

  const openPeriod2 =
    trxDate >= latestOpenPeriodCheckingDate?.StartDate &&
    trxDate <= latestOpenPeriodCheckingDate?.EndDate

  const checkingYearClose1 = openPeriod1 ? true : false
  const checkingYearClose2 = openPeriod2 ? false : true

  const createUpdateLoading = editData
    ? updateARRefundLoading
    : createARRefundLoading

  const createUpdateCalled = editData
    ? updateARRefundCalled
    : createARRefundCalled

  const { fields, append, remove, prepend } = useFieldArray({
    control,
    name: 'Allocation',
  })

  /* -------------------------------------------- */
  /*               DOC DATE VALIDATION            */
  /* -------------------------------------------- */
  const DocDate = watch('DocDate') ? new Date(watch('DocDate')) : null
  const today = new Date()

  const monthsBefore = getDocumentDateValidation?.[0]?.MonthsBefore ?? 12
  const monthsAfter = getDocumentDateValidation?.[0]?.MonthsAfter ?? 1

  // Calculate valid range
  const minValidDate = new Date(today)
  minValidDate.setMonth(minValidDate.getMonth() - monthsBefore)
  minValidDate.setHours(0, 0, 0, 0)

  const maxValidDate = new Date(today)
  maxValidDate.setMonth(maxValidDate.getMonth() + monthsAfter)
  maxValidDate.setHours(23, 59, 59, 999)

  // Validate inclusive range
  const isDocDateInvalid =
    DocDate &&
    (DocDate.getTime() < minValidDate.getTime() ||
      DocDate.getTime() > maxValidDate.getTime())

  /* -------------------------------------------- */
  /*                   FUNCTION                   */
  /* -------------------------------------------- */

  const [selectedBank, setSelectedBank] = useState(null)
  // select bank
  const handleBankChange = event => {
    setSelectedBank(
      getBankAccount.find(x => x?.BankAccountID === event?.target?.value)
    )
    if (event?.target?.value) {
      const BankAccountID = event?.target?.value
      getBankBalance({
        variables: {
          CompanyID,
          BankAccountID,
        },
      })
    }
  }

  const handlePMChange = event => {
    if (
      getPaymentMethod?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name === 'Cheque' ||
      getPaymentMethod
        ?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name?.includes('Card')
    ) {
      setRefundValidation(true)
    } else setRefundValidation(false)
    if (
      getPaymentMethod?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name === 'Cheque'
    ) {
      setValuePicked('Cheque')
    } else if (
      getPaymentMethod
        ?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name?.includes('Card')
    ) {
      setValuePicked('Card')
    }
  }

  //Changing If PM chosed CreditCard
  const [selectedCC, setSelectedCC] = useState(null)
  const creditcard: any = getCreditCardType

  const handleCCChange = event => {
    setSelectedCC(
      creditcard.find(x => x?.CreditCardID === event?.target?.value)
    )
  }

  const handleCreditorDebtorChange = event => {
    remove()
    loadAllocationDocument({
      variables: {
        ...(editData && editData?.DebtorAccountID === event
          ? { entityID: [RefundID] }
          : null),
        creditorDebtorID: event,
        companyID: CompanyID,
        refTable: 'AR_Refund',
      },
    })
  }

  const getTotalAmt = () => {
    if (watch('DebtorAccountID') && watch('Allocation')?.length > 0) {
      return watch('Allocation').reduce((prevValue, currValue) => {
        return prevValue + currValue?.AllocationAmt
      }, 0)
    } else {
      return 0
    }
  }

  /** This is for permission purposes */
  const { handlePermDisabled } = usePermissionChecker()
  /**ACL */

  /* -------------------------------------------- */
  /*                   USEEFFECT                  */
  /* -------------------------------------------- */
  useEffect(() => {
    if (editData?.Allocation) {
      let allocatedArr = editData?.Allocation
      allocatedArr?.map(allocated => {
        if (!(allocated[`${allocated?.CreditOrDebit}ID`] in allocatedObj)) {
          allocatedObj[allocated[`${allocated?.CreditOrDebit}ID`]] =
            allocated?.AllocationAmt
        }
      })
    }
    if (editData?.BankAccountID) {
      const BankAccountID = editData?.BankAccountID
      getBankBalance({
        variables: {
          CompanyID,
          BankAccountID,
        },
      })
    }
  }, [editData])

  useEffect(() => {
    if (editData?.DebtorAccountID) {
      loadAllocationDocument({
        variables: {
          entityID: RefundID,
          creditorDebtorID: editData?.DebtorAccountID,
          companyID: CompanyID,
          refTable: 'AR_Refund',
        },
      })
    }
  }, [allocatedObj, editData])

  // Edit Bank Account
  useEffect(() => {
    if (!!editData && !!getBankAccount) {
      setSelectedBank(
        getBankAccount?.find(e => e?.BankAccountID === editData?.BankAccountID)
      )
    }
  }, [editData, getBankAccount])

  /* -------------------------------------------- */
  /*                  ATTACHMENT                  */
  /* -------------------------------------------- */
  const {
    files,
    setFiles,
    setPreviewFiles,
    handleUploadChange,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
  } = useUploadAttachment()

  const [
    loadDoc,
    { loading: DocLoad, error: DocError, data: DocData },
  ] = useDocumentListingLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ DocumentListing }) => {
      if (!editData?.files) {
        handleEditUpload(
          DocumentListing?.filter(doc => doc?.description !== 'document_pdf')
        )
        previewFiles?.push(
          ...DocumentListing?.filter(
            doc => doc?.description !== 'document_pdf'
          )?.map(x => x?.fileURL)
        )
      }
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  useEffect(() => {
    if (!DocLoad && formMode !== 'add') {
      loadDoc({ variables: { refID: RefundID } })
    }
    if (editData?.files) {
      setFiles(editData?.files)
      setPreviewFiles(
        editData?.files?.map(file => {
          return URL.createObjectURL(file)
        })
      )
    }
  }, [formMode, RefundID, editData])

  /* -------------------------------------------- */
  /*                    FOOTER                    */
  /* -------------------------------------------- */
  const draftFooterOption = {
    name: 'Save as Draft',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'draft'))()
    },
    color: 'primary',
    props: {
      type: 'submit',
    },

    disabled:
      checkingYearClose2 || isDocDateInvalid
        ? true
        : handlePermDisabled({
            companyID: CompanyID,
            permEnum: AcctPermission.AccReceivableRefundDraft,
          }),
  }

  const rejectFooterOption = {
    name: 'Save',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'reject'))()
    },
    color: 'primary',
    props: {
      type: 'submit',
    },

    disabled:
      !!errors?.DocDate ||
      !!errors?.TrxDate ||
      !!errors?.DebtorAccountID ||
      !!errors?.PaymentMethodID ||
      !!errors?.RefNo ||
      !!errors?.BankAccountID ||
      !!errors?.Description ||
      checkingYearClose2 ||
      isDocDateInvalid
        ? true
        : handlePermDisabled({
            companyID: CompanyID,
            permEnum: AcctPermission.AccReceivableRefundDraft,
          }),
  }

  const submitFooterOption = {
    name: 'Submit',
    onClick: e => {
      handleSubmit(data =>
        getDocumentNumberHeader?.filter(x => x?.RefTable === 'AR_Refund')
          ?.length === 0
          ? (setOpenSnackBar(true),
            setSnackBarMsg(SystemMsgs.errorNumberingStructure()))
          : !createUpdateCalled && onSubmit(data, 'submit')
      )()
      setIsSubmit(true)
    },
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled:
      !(
        watch('Allocation')?.filter(alloc => Number(alloc?.AllocationAmt))
          ?.length > 0
      ) ||
      checkingYearClose2 ||
      isDocDateInvalid
        ? true
        : false,
  }

  let footerOptions: any[]
  if (editData?.mode === 'resubmit') {
    footerOptions = [rejectFooterOption, submitFooterOption]
  } else {
    footerOptions = [draftFooterOption, submitFooterOption]
  }

  /* -------------------------------------------- */
  /*               EXIT CONFIRMATION              */
  /* -------------------------------------------- */
  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: editData,
      formMode: formMode,
      // for attachment
      initFiles: initDocs,
      currFiles: files?.map(file => file?.name),
      // for allocation
      hasAllocation: true,
    })

  return (
    <>
      {bankAccountLoading && <Loading />}
      {createUpdateLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      {DebtorAccountLoading && <Loading />}
      {PaymentMethodLoading && <Loading />}
      {updateARRefundLoading && <Loading />}
      {getBankBalanceLoading && <Loading />}
      {createARRefundLoading && <Loading />}
      {CreditCardTypeLoading && <Loading />}
      {openPeriodCheckDateLoading && <Loading />}
      {getAllocationDocumentLoading && <Loading />}

      <MainHeader
        mainBtn="close"
        onClick={() => {
          hasChanges() === true
            ? setOpenExitConf(true)
            : history.push(`/account-receivable/${CompanyID}/refund`)
          localStorage.removeItem('DebitAmt')
        }}
        smTitle={'Account Receivable'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Account Receivable' },
          { name: 'AR Submenu' },
          { name: 'Refund Listing' },
          { name: 'Refund', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              mode === 'add'
                ? 'New'
                : mode === 'approve-reject'
                ? 'Approve/Reject'
                : 'Edit',
            current: true,
          },
        ]}
      />

      <ContentWrapper float footer>
        <CardContents
          section={{
            header: {
              title: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span>Refunds details</span>
                  {formMode === 'edit' && (
                    <IconText
                      icon={
                        <img
                          src={AuditLog}
                          style={{
                            width: '17px',
                            marginLeft: '12px',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            history.push({
                              pathname: `/account-receivable/${CompanyID}/refund/${RefundID}/detail/audit-log`,
                              state: {
                                ID: editData?.RefundID,
                                tableName: 'AR_Refund',
                                primaryKey: 'RefundID',
                                ...editData,
                              },
                            })
                          }}
                        />
                      }
                      font="desc"
                    />
                  )}
                </div>
              ),
            },
          }}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              required
              as={KeyboardDatePicker}
              name="DocDate"
              label="Document Date"
              control={control}
              onChange={(date: Date | null) => {}}
              format="dd/MM/yyyy"
              value={watch(formMode === 'add' ? new Date() : editData?.DocDate)}
              margin="dense"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              className="left"
              defaultValue={editData ? editData?.DocDate : new Date()}
              showTodayButton
              disabled={mode == 'approve-reject'}
              helperText={
                isDocDateInvalid
                  ? 'Document date is not within the validation range'
                  : errors?.DocDate?.message
              }
              error={errors?.DocDate || isDocDateInvalid ? true : false}
            />
          </MuiPickersUtilsProvider>

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="TrxDate"
              required
              label="Transaction Date"
              control={control}
              format="dd/MM/yyyy"
              margin="dense"
              allowKeyboardControl
              onChange={(date: Date | null) => {}}
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              showTodayButton
              className="right"
              value={new Date()}
              defaultValue={editData ? editData?.TransactionDate : new Date()}
              minDate={new Date(latestOpenPeriodCheckingDate?.StartDate)}
              maxDate={new Date(latestOpenPeriodCheckingDate?.EndDate)}
              helperText={
                checkingYearClose2
                  ? 'Financial Period already closed'
                  : errors?.TrxDate?.message
              }
              error={errors?.TrxDate || checkingYearClose2 ? true : false}
            />
          </MuiPickersUtilsProvider>

          {!DebtorAccountLoading && (
            <Controller
              render={({ value, onChange }) => {
                const defVal = getDebtorAccountListing?.filter(
                  x => x?.DebtorAccountID === editData?.DebtorAccountID
                )[0]
                return (
                  <Autocomplete
                    options={
                      getDebtorAccountListing?.sort((a, b) => {
                        return a.DebtorName.localeCompare(b.DebtorName)
                      }) || []
                    }
                    getOptionLabel={option => `${option?.DebtorName}`}
                    fullWidth
                    onChange={(value, newValue: any) => {
                      setValue('DebtorAccountID', newValue?.DebtorAccountID)
                      handleCreditorDebtorChange(newValue?.DebtorAccountID)
                      clearErrors('DebtorAccountID')
                    }}
                    renderOption={(props, option) => {
                      return <span>{props?.DebtorName}</span>
                    }}
                    defaultValue={defVal}
                    disabled={mode === 'approve-reject'}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            helperText={errors?.DebtorAccountID?.message}
                            error={errors?.DebtorAccountID ? true : false}
                            label="Debtor Name"
                            style={{ width: '100%' }}
                            margin="dense"
                            required
                          />
                        </div>
                      )
                    }}
                  />
                )
              }}
              label="Debtor Name"
              name="DebtorAccountID"
              autoComplete="off"
              control={control}
              multiline={true}
              fullWidth
              margin="dense"
              ref={register}
              helperText={errors?.DebtorAccountID?.message}
              error={errors?.DebtorAccountID ? true : false}
              defaultValue={editData?.DebtorAccountID}
              required
              disabled={mode === 'approve-reject'}
            />
          )}

          <Controller
            render={({ onChange, value }) => (
              <TextField
                label="Refund Method"
                required
                select
                value={value}
                margin="dense"
                onChange={e => {
                  onChange(e)
                  handlePMChange(e)
                  setValue('PaymentMethodID', e?.target?.value)
                }}
                // defaultValue={editData ? editData?.PaymentMethodID : ''}
                disabled={formMode === 'approve-reject'}
                helperText={errors?.PaymentMethodID?.message}
                error={errors?.PaymentMethodID ? true : false}
              >
                {getPaymentMethod
                  ?.sort((a, b) => {
                    return a.Name.localeCompare(b.Name)
                  })
                  .map((el, index) => (
                    <MenuItem key={index} value={el.PaymentMethodID}>
                      {el.Name}
                    </MenuItem>
                  ))}
              </TextField>
            )}
            onChange={e => {
              //handlePMChange(e)
              setValue('PaymentMethodID', e?.target?.value)
            }}
            control={control}
            ref={register}
            name="PaymentMethodID"
            autoComplete="off"
            // value={editData?.PaymentMethodID}
            margin="dense"
            multiline={true}
            fullWidth
            required
          />

          {getPaymentMethod
            .find(el => el.PaymentMethodID === watch('PaymentMethodID'))
            ?.Name?.includes('Card') && (
            <Controller
              render={({ onChange, value }) => (
                <TextField
                  select
                  required
                  name="CreditCardID"
                  margin="dense"
                  label="Card Type"
                  onChange={e => {
                    onChange(e)
                    handleCCChange(e)
                    //setValue('CreditCardID', e?.target?.value)
                  }}
                  defaultValue={editData ? editData?.CreditCardID : ''}
                  disabled={mode == 'approve-reject'}
                  // helperText={errors?.CreditCardID?.message}
                  // error={errors?.CreditCardID ? true : false}
                >
                  {getCreditCardType
                    ?.sort((a, b) => {
                      return a.Name.localeCompare(b.Name)
                    })
                    .map((el, index) => (
                      <MenuItem key={index} value={el.CreditCardID}>
                        {`${el.Name}`}
                      </MenuItem>
                    ))}
                </TextField>
              )}
              label="Card Type"
              name="CreditCardID"
              autoComplete="off"
              control={control}
              // helperText={errors?.CreditCardID?.message}
              // error={errors?.CreditCardID ? true : false}
              multiline={true}
              // defaultValue={getRefund[0]?.CreditCardID}
              fullWidth
              margin="dense"
              ref={register}
            />
          )}

          {getPaymentMethod.find(
            el => el.PaymentMethodID === watch('PaymentMethodID')
          )?.Name === 'Cheque' && (
            <>
              <Controller
                as={TextField}
                id="standard-basic"
                name="ChequeNo"
                label="Cheque No"
                className="left"
                autoComplete="off"
                control={control}
                margin="dense"
                required
                ref={register}
                // helperText={errors?.ChequeNo?.message}
                // error={errors?.ChequeNo ? true : false}
                defaultValue={editData ? editData?.ChequeNo : ''}
                disabled={mode == 'approve-reject'}
              />

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Controller
                  required
                  as={KeyboardDatePicker}
                  name="ChequeDate"
                  label="Cheque Date"
                  control={control}
                  onChange={(date: Date | null) => {}}
                  format="dd/MM/yyyy"
                  value={
                    // formMode === 'add' ? new Date() : editData?.ChequeDate
                    watch('ChequeDate')
                  }
                  margin="dense"
                  allowKeyboardControl
                  //inputRef={register({})}
                  ref={register}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  defaultValue={
                    formMode === 'add' ? new Date() : editData?.ChequeDate
                  }
                  showTodayButton
                  className="right"
                  disabled={mode == 'approve-reject'}
                  // helperText={errors?.ChequeDate?.message}
                  // error={errors?.ChequeDate ? true : false}
                />
              </MuiPickersUtilsProvider>
            </>
          )}

          <Controller
            as={TextField}
            id="standard-basic"
            name="RefNo"
            label="Reference No."
            required
            autoComplete="off"
            control={control}
            margin="dense"
            ref={register}
            helperText={errors?.RefNo?.message}
            error={errors?.RefNo ? true : false}
            defaultValue={editData ? editData?.RefNo : ''}
            disabled={mode == 'approve-reject'}
          />

          <DropdownTextfield
            // mount={bankNameNeeded}
            disabled={formMode === 'approve-reject' ? true : false}
            helperText={errors?.BankAccountID?.message}
            error={errors?.BankAccountID ? true : false}
            label="Bank Account No."
            handleChangeEnabled
            handleChange={handleBankChange}
            selectProps={{
              renderValue: () =>
                `${selectedBank?.AccountNo} (${selectedBank?.BankProfile?.Name} | ${selectedBank?.Code})`,
            }}
            customDropdown={getBankAccount?.map((el, index) => (
              <MenuItem
                id="contract-select"
                key={index}
                value={el?.BankAccountID}
              >
                <div className="content-wrap full">
                  <div>
                    <span className="xsTitle">
                      {el.BankProfile?.Name} ({el.BankProfile?.Address?.city})
                    </span>
                  </div>
                  <div className="desc">
                    Account No: {`${el?.AccountNo} (${el?.Code})`}
                  </div>
                </div>
              </MenuItem>
            ))}
            name="BankAccountID"
            control={control}
            register={register}
            // defaultValue={watch(`BankAccountID`)}
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="Description"
            label="Description"
            required
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            helperText={errors?.Description?.message}
            error={errors?.Description ? true : false}
            ref={register}
            defaultValue={
              formMode === 'edit' || mode === 'approve-reject'
                ? editData?.Description
                : ''
            }
            disabled={mode === 'approve-reject'}
            // style={{ marginBottom: '44px' }}
            multiline
          />

          <VoiceTextField
            mounted={true}
            label="Remark"
            name="Remark"
            value={voiceRemark}
            setValue={setValue}
            record={record}
            setRecord={setRecord}
            control={control}
            controllerProps={{
              error: errors?.Remark ? true : false,
              helperText: errors?.Remark?.message,
              ref: register,
              autoComplete: 'off',
            }}
            required
          />

          <DocUploadInput
            placeholder={previewFiles.length === 0 ? 'Attachment' : null}
            label={previewFiles.length > 0 ? 'Attachment' : null}
            files={files}
            onHandleUploadChange={handleUploadChange}
            multiple
            accept={
              'application/msword, application/*, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            }
            mapData={'application'}
            imagePreview={
              <>
                {previewFiles?.map((v, i) => (
                  <UploadPreview
                    remove
                    key={v}
                    src={v}
                    onClick={() => removeFile(i)}
                    mediaType={
                      // files[i]?.type
                      files[i]?.type ?? DocData?.DocumentListing[i]?.mediaType
                    }
                  />
                ))}
              </>
            }
            disabled={mode === 'approve-reject'}
          />
        </CardContents>

        {watch('DebtorAccountID') && (
          <FormAllocationTableContent
            fields={fields}
            headerRightTitle={''}
            watch={watch}
            errors={errors}
            register={register}
            control={control}
            setValue={setValue}
            clearErrors={clearErrors}
            setError={setError}
            allocatedObj={allocatedObj}
            headerStyle={{
              backgroundColor: '#faf2e8',
              color: '#ff9800',
              fontWeight: '700',
            }}
            hasCheckbox={true}
          />
        )}
      </ContentWrapper>

      {footerOptions?.length > 0 ? (
        <AccountFooter options={[...footerOptions]} />
      ) : null}

      <TotalAmountFooter docAmt={getTotalAmt() ?? 0} />

      <CommonDialog
        fullWidth={true}
        open={openExitDialog}
        onClose={() => setopenExitDialog(false)}
        sections={{
          header: {
            title: 'Exit Confirmation',
          },
          body: () => (
            <>
              <div>
                Are you sure you want to exit? Your changes will not be saved.
              </div>
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => setopenExitDialog(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => history.goBack(),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <CommonDialog
        fullWidth={true}
        open={errorDia}
        onClose={() => setErrorDia(false)}
        sections={{
          header: {
            children: (
              <ListItem className="remove-padding">
                <ListItemText
                  primary={
                    <>
                      <span
                        className="smTitle flex-space"
                        style={{ color: 'red' }}
                      >
                        {'Document Numbering is empty'}
                      </span>
                    </>
                  }
                />
              </ListItem>
            ),
          },
          body: () => (
            <div>
              <span>{'Please setup Document Numbering to Submit'}</span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => setErrorDia(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/account-receivable/${CompanyID}/refund`)
        }}
        // hasInfo={hasInfo}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
